import { createFileRoute } from '@tanstack/react-router';

import { ForgotPassword } from '../../modules/auth/components/forgot-password';

const AuthForgotPasswordRoute = () => <ForgotPassword />;

export const Route = createFileRoute('/auth/forgot-password')({
  component: AuthForgotPasswordRoute,
});
